/**
 * 記事本文パーツ（旧テーマ互換）の動作
 * - トグル（.sc_toggle_box）の開閉
 */
const initDiverParts = () => {
    $(document).on('click', '.sc_toggle_box .sc_toggle_title', function () {
        $(this).toggleClass('active');
    });
};

export default initDiverParts;
